import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JustMapExtentService {
  private readonly justMapExtentBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject(true);

  get justMapExtent$(): Observable<boolean> {
    return this.justMapExtentBehaviorSubject.asObservable();
  }

  get justMapExtent(): boolean {
    return this.justMapExtentBehaviorSubject.value;
  }

  constructor() {}

  set(justMapExtent: boolean) {
    this.justMapExtentBehaviorSubject.next(justMapExtent);
  }
}
